var map = {
	"./BACKGROUND.png": 321,
	"./BUBBLE_FIELD_BACKGROUND.png": 322,
	"./bg_shadow.png": 323,
	"./orientationScreen.png": 324,
	"./shadow.png": 325,
	"./shoutout_bg.png": 326,
	"./warning_pillar.png": 327
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 320;